"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { EditorTagContext } from './use-editor-tag-renderer.mjs';

function EditorTagContextProvider({ children, renderer }) {
  return /* @__PURE__ */ jsx(EditorTagContext.Provider, { value: renderer, children });
}

export { EditorTagContextProvider };
